'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var asyncEachSeries = require('async/eachSeries');

var waterfall = require('async/waterfall');

var dagPB = require('ipld-dag-pb');

var UnixFS = require('ipfs-unixfs');

var DAGLink = dagPB.DAGLink;
var DAGNode = dagPB.DAGNode;

var Dir = require('./dir');

var persist = require('../utils/persist');

var DirFlat =
/*#__PURE__*/
function (_Dir) {
  _inherits(DirFlat, _Dir);

  function DirFlat(props, _options) {
    var _this;

    _classCallCheck(this, DirFlat);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirFlat).call(this, props, _options));
    _this._children = {};
    return _this;
  }

  _createClass(DirFlat, [{
    key: "put",
    value: function put(name, value, callback) {
      this.multihash = undefined;
      this.size = undefined;
      this._children[name] = value;
      process.nextTick(callback);
    }
  }, {
    key: "get",
    value: function get(name, callback) {
      var _this2 = this;

      process.nextTick(function () {
        return callback(null, _this2._children[name]);
      });
    }
  }, {
    key: "childCount",
    value: function childCount() {
      return Object.keys(this._children).length;
    }
  }, {
    key: "directChildrenCount",
    value: function directChildrenCount() {
      return this.childCount();
    }
  }, {
    key: "onlyChild",
    value: function onlyChild(callback) {
      var _this3 = this;

      process.nextTick(function () {
        return callback(null, _this3._children[Object.keys(_this3._children)[0]]);
      });
    }
  }, {
    key: "eachChildSeries",
    value: function eachChildSeries(iterator, callback) {
      var _this4 = this;

      asyncEachSeries(Object.keys(this._children), function (key, callback) {
        iterator(key, _this4._children[key], callback);
      }, callback);
    }
  }, {
    key: "flush",
    value: function flush(path, ipld, source, callback) {
      var _this5 = this;

      var links = Object.keys(this._children).map(function (key) {
        var child = _this5._children[key];
        return new DAGLink(key, child.size, child.multihash);
      });
      var dir = new UnixFS('directory');
      waterfall([function (callback) {
        return DAGNode.create(dir.marshal(), links, callback);
      }, function (node, callback) {
        return persist(node, ipld, _this5._options, callback);
      }, function (_ref, callback) {
        var cid = _ref.cid,
            node = _ref.node;
        _this5.multihash = cid.buffer;
        _this5.size = node.size;
        var pushable = {
          path: path,
          multihash: cid.buffer,
          size: node.size
        };
        source.push(pushable);
        callback(null, node);
      }], callback);
    }
  }]);

  return DirFlat;
}(Dir);

module.exports = createDirFlat;

function createDirFlat(props, _options) {
  return new DirFlat(props, _options);
}